import * as ActionConfigurationManager from './config.actions';

export const loadConfirmationNumber = ActionConfigurationManager.LOAD_CONFIRMATION_NUMBER